/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-down-left': {
    width: 17,
    height: 17,
    viewBox: '0 0 17 17',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.995 7.038a.5.5 0 0 1 0 .707l-2.98 2.98 2.98 2.98a.5.5 0 1 1-.707.707l-3.333-3.334a.5.5 0 0 1 0-.707l3.333-3.333a.5.5 0 0 1 .707 0z" _fill="#737373"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M13.975 2.892a.5.5 0 0 1 .5.5v4.666a3.167 3.167 0 0 1-3.167 3.167h-8a.5.5 0 1 1 0-1h8c.575 0 1.126-.228 1.533-.635m0 0c.406-.406.634-.957.634-1.532V3.392a.5.5 0 0 1 .5-.5" _fill="#737373"/>'
  }
})
